const {EventRPCBridge} = require('../EventRPCBridge');

/**
 * A bridge to interact with the Webkit message handler which is used to communicate with the native side on iOS applications.
 * Applications should register a WKScriptMessageHandler called "shared" which will be used to communicate with the native side.
 * To send data back to this bridge, the native side should post a message to the window with the event name "nativeMethodComplete"
 */
class WebkitSharedNativeBridge {
	/**
	 * @type {EventRPCBridge}
	 * @private
	 */
	_eventBridge;

	constructor() {
		if(!window.webkit?.messageHandlers?.shared) {
			console.error('No native message message handler found but native bridge was constructed. This is likely indicative of an problem');
		}

		this._eventBridge = new EventRPCBridge({
			postMessage: this._postMessage.bind(this),
		});

		this._listenForRPCMessages();
	}

	/**
	 * Begins listening for the native method complete event which should be fired by the native side.
	 * This is how we know when a native method has completed and get its results
	 * @private
	 */
	_listenForRPCMessages() {
		console.log('Attaching native method complete event listener');
		window.addEventListener('nativeMethodComplete', 
		(event) => {
			const detail = event.detail;
			if(detail) {
				this._eventBridge.onRPCMethodComplete(detail);
			}
		});
	}

	_postMessage(message) {
		const messageBus = window.webkit?.messageHandlers?.shared;
		if(messageBus && messageBus.postMessage) {
			messageBus.postMessage({
				objcMethod: message.method,
				callbackId: message.callbackId,
				params: message.payload,
			});
		} else {
			throw new Error('Could not post message due to missing webkit message handler')
		}
	}


	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	async invokeNativeMethod(method, args) {
		return this._eventBridge.invokeRPCMethod(method, args);
	}
}

WebkitSharedNativeBridge.supported = () => {
	return Boolean(window.webkit?.messageHandlers?.shared?.postMessage);
}


module.exports = {
	WebkitSharedNativeBridge,
}